import {
  onSnapshot,
  onSnapshotsInSync,
  collection,
  doc,
} from 'firebase/firestore';
import { useState, createContext, useEffect } from 'react';
import db from '../../firebaseConfig';

export const DataContext = createContext();

export const DataProvider = (props) => {
  const [projects, setProjects] = useState([]);
  const [skills, setSkills] = useState([]);
  const [journey, setJourney] = useState([]);
  const [majorLinks, setMajorLinks] = useState({});

  useEffect(() => {
    console.log('db', db);
    const unsubscribe1 = onSnapshot(collection(db, 'projects'), (snapShot) => {
      let obj = {};
      const projectArray = [];
      snapShot.docs.map((doc) => {
        projectArray.push({ ...doc.data(), id: doc.id });
        // obj[doc.id] = { ...doc.data(), id: doc.id };
      });
      projectArray.sort((a, b) => b.priority - a.priority);
      projectArray.map((project) => {
        obj[project.id] = project;
      });
      setProjects(obj);
    });

    const unsubscribe2 = onSnapshot(collection(db, 'journey'), (snapShot) => {
      let arr = snapShot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      arr.sort(sortByDate);
      setJourney(arr);
    });

    const unsubscribe3 = onSnapshot(
      collection(db, 'majorLinks'),
      (snapShot) => {
        let arr = snapShot.docs.map((doc) => {
          return { ...doc.data(), id: doc.id };
        });
        const links = {};
        arr.map((item) => {
          links[item.id] = item;
        });
        setMajorLinks(links);
      }
    );

    return () => {
      unsubscribe1();
      unsubscribe2();
      unsubscribe3();
    };
  }, []);

  const sortByDate = (a, b) => {
    let date1 = a.duration.substring(a.duration.length - 4, a.duration.length);
    let date2 = b.duration.substring(b.duration.length - 4, b.duration.length);
    console.log('Comparing ', date1, ' and ', date2);
    if (date1 < date2) return 1;
    else return -1;
  };

  return (
    <DataContext.Provider value={{ projects, skills, journey, majorLinks }}>
      {props.children}
    </DataContext.Provider>
  );
};
